/* ==========================================================================
   RAM Bikes — product page
   ==========================================================================
   1. Variant picker: the option radios (colour swatches / pills) resolve to
      a variant; price, compare-at, availability, the hidden id the native
      form posts, the gallery image and ?variant= in the URL all follow.
   2. Gallery dots switch the visible media.
   3. Recommendations: fetches the section from Shopify's product
      recommendations endpoint and swaps the grid in.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-product]');
  var dataEl = document.querySelector('[data-product-json]');
  if (!root || !dataEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var variants = data.variants || [];
  var form = root.querySelector('[data-product-form]');
  var idInput = root.querySelector('[data-variant-id]');
  var addBtn = root.querySelector('[data-add-to-cart]');
  var addLabel = root.querySelector('[data-add-label]');
  var unavailable = root.querySelector('[data-unavailable]');
  var priceNow = root.querySelector('[data-price-now]');
  var priceWas = root.querySelector('[data-price-was]');
  var finance = root.querySelector('[data-finance]');

  /* ---- money -------------------------------------------------------- */
  function formatMoney(cents) {
    var fmt = data.moneyFormat || '${{amount}}';
    var amount = (cents / 100);
    var whole = Math.floor(amount);
    var frac = Math.round((amount - whole) * 100);
    function group(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    var out;
    if (/amount_no_decimals/.test(fmt)) out = group(Math.round(amount));
    else if (/amount_with_comma_separator/.test(fmt)) out = String(amount.toFixed(2)).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    else out = group(whole) + (frac ? '.' + (frac < 10 ? '0' + frac : frac) : '');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, out).replace(/<[^>]+>/g, '');
  }

  /* ---- variant resolution ------------------------------------------ */
  function selectedOptions() {
    var opts = [];
    root.querySelectorAll('[data-option-index]').forEach(function (fs) {
      var checked = fs.querySelector('input:checked');
      opts[Number(fs.getAttribute('data-option-index'))] = checked ? checked.value : null;
    });
    return opts;
  }

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function showMedia(mediaId) {
    var items = root.querySelectorAll('[data-gallery-item]');
    var dots = root.querySelectorAll('[data-gallery-dot]');
    if (!items.length) return;
    var found = false;
    items.forEach(function (el) {
      var on = String(el.getAttribute('data-media-id')) === String(mediaId);
      el.hidden = !on;
      if (on) found = true;
    });
    if (!found) { items.forEach(function (el, i) { el.hidden = i !== 0; }); }
    dots.forEach(function (d) {
      var on = found ? String(d.getAttribute('data-media-id')) === String(mediaId) : d === dots[0];
      d.classList.toggle('is-active', on);
      d.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  function render(variant) {
    if (!variant) {
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = data.strings.unavailable;
      if (unavailable) unavailable.hidden = false;
      return;
    }
    if (unavailable) unavailable.hidden = true;
    if (idInput) idInput.value = variant.id;
    if (priceNow) priceNow.textContent = formatMoney(variant.price);
    if (priceWas) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceWas.textContent = formatMoney(variant.compare_at_price);
        priceWas.hidden = false;
      } else {
        priceWas.hidden = true;
      }
    }
    if (finance) {
      var months = Number(finance.getAttribute('data-months')) || 12;
      var monthly = Math.floor(variant.price / months / 100) * 100;
      finance.textContent = finance.textContent.replace(/[^\s]*\d[\d.,]*/, formatMoney(monthly));
    }
    if (addBtn) addBtn.disabled = !variant.available;
    if (addLabel) addLabel.textContent = variant.available ? data.strings.add : data.strings.soldOut;
    if (variant.featured_media) showMedia(variant.featured_media.id);

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  root.querySelectorAll('[data-option-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      render(findVariant(selectedOptions()));
    });
  });

  /* ---- gallery dots ------------------------------------------------- */
  root.querySelectorAll('[data-gallery-dot]').forEach(function (dot) {
    dot.addEventListener('click', function () { showMedia(dot.getAttribute('data-media-id')); });
  });

  /* ---- native form: keep the submit honest -------------------------- */
  if (form) {
    form.addEventListener('submit', function (event) {
      if (addBtn && addBtn.disabled) event.preventDefault();
    });
  }

  /* ---- recommendations ---------------------------------------------- */
  var rec = document.querySelector('[data-recommendations]');
  if (rec && rec.getAttribute('data-url')) {
    var load = function () {
      fetch(rec.getAttribute('data-url'))
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.querySelectorAll('.product').length) rec.innerHTML = fresh.innerHTML;
        })
        .catch(function () { /* keep the server-rendered fallback */ });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '400px' });
      io.observe(rec);
    } else {
      load();
    }
  }
})();
